export default "__VITE_ASSET__CJLC5XM$__"